import React, { useEffect, useState } from "react"
import { Link as ReactRouter, useNavigate } from "react-router-dom"

// Hooks and Redux
import { useAppSelector } from "../../../redux/hooks"

import { Box, IconButton, Typography, Chip } from "@mui/material"
import Tooltip from "@mui/material/Tooltip"
import { useTranslation } from "react-i18next"
import { Link as ReactRouterLink } from "react-router-dom"
import { DataGrid, GridCellParams, GridColDef, enUS } from "@mui/x-data-grid"
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded"
import { thTHGrid } from "../../../@types/DataGridLocaleText"
import dayjs from "dayjs"
import { Site } from "../../../@types"

// Services
// import { getAllSites } from "../../../services/SiteService" //เปลี่ยนมาใช้ useAppSelector

interface statusCompleteTableProps {
  index: number
  value: number
  data: any[]
}

const JobsStatusCompleteTable: React.FC<statusCompleteTableProps> = (props) => {
  const { index, value, data, ...other } = props
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()

  // เปลี่ยนมาใช้ useAppSelector
  // const [sitesData, setSitesData] = useState<Site[]>([])
  const { sites: sitesData } = useAppSelector((state) => state.masterData)
  const { statuses: statusData } = useAppSelector((state) => state.masterData)

  // เปลี่ยนมาใช้ useAppSelector
  // useEffect(() => {
  //   const fetchSites = async () => {
  //     try {
  //       const response = await getAllSites()

  //       if (response.data?.success) {
  //         const sitesData = response.data?.sites

  //         setSitesData(sitesData)
  //       }
  //     } catch (error) {
  //       navigate("/servererror", { replace: true })
  //     }
  //   }
  //   fetchSites()
  // }, [navigate])

  const columns: GridColDef[] = [
    {
      field: "viewmore",
      headerName: "",
      width: 70,
      renderCell: (params) => {
        if (params.row.comment !== "ec-excel") {
          return (
            <Tooltip title={t("View more details")}>
              <IconButton
                color="info"
                sx={{ borderRadius: 2 }}
                component={ReactRouterLink}
                to={`/jobs_status/appformdetail/${params.row.id}?content_type=completedTable`}
              >
                <VisibilityRoundedIcon />
              </IconButton>
            </Tooltip>
          )
        }

        return null
      },
    },
    {
      field: "position_name",
      headerName: `${t("Position")}`,
      width: 230,
      renderCell: (params: GridCellParams) => {
        let jobPosition = params?.row?.Job?.job_name || " - "

        return <Typography sx={{ fontSize: 14 }}>{jobPosition}</Typography>
      },
    },
    {
      field: "Site",
      headerName: `${t("Site")}`,
      width: 200,
      renderCell: (params: GridCellParams) => {
        const siteCheck = sitesData.find(
          (item: any) => params?.row?.site_id === item.site_id
        )
        let site = params?.row?.Job?.Site?.site_name
          ? params?.row?.Job?.Site?.site_name
          : siteCheck?.site_name || " - "

        return <Typography sx={{ fontSize: 14 }}>{site}</Typography>
      },
    },
    {
      field: "status_name",
      headerName: `${t("Status")}`,
      width: 250,
      renderCell: (params: GridCellParams) => {
        const status = statusData?.find(
          (item) => item.id === params.row.Status.id
        )
        let status_applicant =
          localStorage.language === "th"
            ? status?.show_on_applicant
            : status?.show_on_applicant_en
        let statusColor = params?.row?.Status?.color || ""

        return (
          <Chip
            variant="outlined"
            sx={{
              bgcolor: statusColor,
              borderColor: statusColor,
              fontWeights: "normal",
              color: "white",
              my: 2,
            }}
            size="medium"
            label={status_applicant}
          />
        )
      },
    },
    {
      field: "created_date",
      headerName: `${t("Apply Date")}`,
      width: 150,
      renderCell: (params: GridCellParams) => {
        let created_date = dayjs(params.row.created_date).format(
          "MM/DD/BBBB HH:mm"
        )

        return <Typography sx={{ fontSize: 14 }}>{created_date}</Typography>
      },
    },
    {
      field: "modified_date",
      headerName: `${t("Last Modified Date")}`,
      width: 150,
      renderCell: (params: GridCellParams) => {
        if (params.row.modified_date) {
          let modified_date =
            dayjs(params.row.modified_date).format("MM/DD/BBBB HH:mm") ?? "-"

          return <Typography sx={{ fontSize: 14 }}>{modified_date}</Typography>
        } else {
          return <Typography sx={{ fontSize: 14 }}>-</Typography>
        }
      },
    },
  ]

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {data.length ? (
        <DataGrid
          getRowId={(row) => row.id}
          getRowHeight={() => "auto"}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          pageSizeOptions={[10, 20, 30, 40, 50]}
          rows={data}
          columns={columns}
          disableColumnMenu
          disableRowSelectionOnClick
          sx={{
            "&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus, &.MuiDataGrid-root .MuiDataGrid-cell:focus":
              {
                outline: "none !important",
              },
            fontSize: 15,
          }}
          localeText={
            i18n.language === "en"
              ? enUS.components.MuiDataGrid.defaultProps.localeText
              : thTHGrid
          }
        />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          marginY={7}
          gap={2}
        >
          <Typography
            align="center"
            sx={{ fontSize: { xs: "14px", sm: "16px" }, letterSpacing: 0.5 }}
          >
            {t("No completed job positions found")}
          </Typography>
        </Box>
      )}
    </div>
  )
}

export default JobsStatusCompleteTable
